import { render, staticRenderFns } from "./RrcvL_List.vue?vue&type=template&id=0033b4a8"
import script from "./RrcvL_List.vue?vue&type=script&lang=js"
export * from "./RrcvL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports